<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary"
        data-toggle="modal"
        data-target="#localizationModal"
        @click="localizationModal({ action: 'add' })"
      >
        新增
      </button>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table :rows="rows" :columns="columns" :config="config">
        <template slot="Sort" slot-scope="scope">
          <div class="text-center">
            <button
              v-if="scope.row.vbt_id !== 1"
              class="btn btn-outline-secondary btn-sm"
              @click="
                changeSort({
                  guid: scope.row.LocalizationTypeGuid,
                  action: 'up',
                })
              "
              style="margin: 0 2px"
            >
              <i class="fas fa-long-arrow-alt-up" />
            </button>
            <button
              v-if="scope.row.vbt_id !== rows.length"
              class="btn btn-outline-secondary btn-sm"
              @click="
                changeSort({
                  guid: scope.row.LocalizationTypeGuid,
                  action: 'down',
                })
              "
              style="margin: 0 2px"
            >
              <i class="fas fa-long-arrow-alt-down" />
            </button>
          </div>
        </template>
        <template slot="IsEnabled" slot-scope="props">
          <el-switch
            active-color="#13ce66"
            inactive-color="#808080"
            @change="changeEnable(props.row)"
            v-model="props.row.IsEnabled"
          />
        </template>

        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#localizationModal"
            @click="localizationModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      id="localizationModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="localization"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增語系</span>
              <span v-else>編輯語系</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="input-localization-name">
                    <span class="mark">*</span>
                    語系名稱
                  </label>
                  <input
                    type="text"
                    id="input-localization-name"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="language.LocalizationTypeName"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Position.PositionName')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="input-localization-code">
                    <span class="mark">*</span>
                    語系代號
                  </label>
                  <input
                    type="text"
                    id="input-localization-code"
                    class="form-control"
                    maxlength="10"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="language.LocalizationTypeCode"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveLocalization)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_noPage_config.js";

export default {
  name: "Localization",

  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      // 判斷新增、編輯
      action: "add",

      // 語系
      language: {},

      rows: [],

      columns: [
        {
          label: "",
          name: "Seq",
          slot_name: "Sort",
        },
        {
          label: "語系名稱",
          name: "LocalizationTypeName",
        },
        {
          label: "語系代號",
          name: "LocalizationTypeCode",
        },

        {
          label: this.i18n("Basic.Enable"),
          name: "IsEnabled",
          slot_name: "IsEnabled",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
      ],

      config: {
        ...config,
      },
    };
  },

  methods: {
    // 新增、編輯 語系 Modal
    localizationModal({ action, data }) {
      switch (action) {
        case "add":
          this.language = {};
          this.action = "add";
          break;
        case "edit":
          this.language = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.localization.reset();
    },

    // 新增、編輯 語系
    saveLocalization() {
      $("#localizationModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.localization
            .postLocalizationType({
              ...this.language
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getLocalization();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.localization
            .putLocalizationType({
              ...this.language
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getLocalization();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 啟用、停用 語系
    changeEnable(data) {
      this.language = { ...data };
      this.action = "edit";
      this.saveLocalization();
    },

    // 變更 語系排序
    changeSort({ guid, action }) {
      this.$api.localization
        .sortLocalizationType({
          LocalizationTypeGuid: guid,
          SortAction: action,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "排序變更成功",
              type: "success",
              duration: 2000,
            });
            this.getLocalization();
          }
        });
    },

    // 取得 語系
    getLocalization() {
      this.updateLoading(true);
      this.$api.localization
        .getLocalizationType({
          isEnabled: null,
        })
        .then((response) => {
          if (response.status === 200) {
            // 繁體中文不顯示在列表上
            this.rows = response.data.filter(
              (element) =>
                element.LocalizationTypeGuid !==
                "a3a7e563-cc36-4a95-be47-c6710798c846"
            );
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getLocalization();
  },
};
</script>
